import { useMemo } from 'react';
import { CustomContent, FieldOptionsWithParser } from '../types';
import { getContentBlockField } from '../utils';

export const useContentBlockFieldParser = <T>(
  customContent: CustomContent[],
  type: string,
  { slug, parser }: FieldOptionsWithParser<T>
) =>
  useMemo(
    () => parser(getContentBlockField(customContent, type, { slug })),
    [customContent, type, slug, parser]
  );
